import { Filter, FilterItem, FilterUcid, Range } from '@app/components/ui/easy-filter/types';
import moment from 'moment';

export const onFilterSend = (data: Filter & Range & FilterUcid) => {
  const result = {
    ...data,
    filter: (data.filter as FilterItem[][]).map((filter) => {
      if (filter.length === 1) {
        return {
          ...filter[0],
          value: Array.isArray(filter[0].value)
            ? filter[0].value.filter((item) => item).length === 1
              ? findComma(filter[0].value[0])
              : filter[0].value
                  .filter((item) => item)
                  .map((i) => findComma(i))
                  .flat(1)
            : findComma(filter[0].value),
        };
      }
      return filter.map((filterItem) => ({
        ...filterItem,
        value: Array.isArray(filterItem.value)
          ? filterItem.value.filter((item) => item).length === 1
            ? findComma(filterItem.value[0])
            : filterItem.value
                .filter((item) => item)
                .map((i) => findComma(i))
                .flat(1)
          : findComma(filterItem.value),
      }));
    }),
  };
  return result;
};
export const onFilterInput = (data: Filter & Range & FilterUcid) => {
  const empty: { filter: FilterItem[][] } = {
    filter: [[{ id: '', condition: '', value: [''] }]],
  };
  const normalizedFilter = data.filter.map((group) => {
    if (Array.isArray(group)) {
      return group;
    } else return [group];
  }) as FilterItem[][];

  const unionFilter = [...normalizedFilter, ...empty.filter];

  const result = {
    ...data,
    range:
      data.range.type === 'r'
        ? {
            ...data.range,
            parameters: [
              {
                condition: data.range.parameters[0]?.condition,
                value:
                  moment(data.range.parameters[0]?.value, 'YYYY-MM-DD').format('DD.MM.yyyy') +
                  ' ' +
                  data.range.parameters[0]?.value.split(' ')[1],
              },
              {
                condition: data.range.parameters[1]?.condition,
                value:
                  moment(data.range.parameters[1]?.value, 'YYYY-MM-DD').format('DD.MM.yyyy') +
                  ' ' +
                  data.range.parameters[1]?.value.split(' ')[1],
              },
            ],
          }
        : data.range,
    filter: unionFilter.map((group) =>
      group.map((item) => ({
        ...item,
        value: Array.isArray(item.value) ? item.value.map(String) : [String(item.value)],
      })),
    ),
  };
  return result;
};

function findComma(word: string) {
  const test = /,/g.test(word);
  if (test) {
    const result = word.split(',').map((word) => word.trim());
    return result;
  }
  return word;
}
